import axios from 'axios';

import type { IAuthToken } from '@/Module/Auth/Model/ApiModel';
import { API_BASE } from '@/Module/Core/Constant';
import type { IResponse } from '@/Module/Core/Model/ApiModel';
import { CookieService } from '@/Module/Core/Service';

export const fetchNewAccessToken = async (refreshToken: string): Promise<IAuthToken | string> => {
  const accessToken = CookieService.getAccessToken();
  return axios
    .post(
      `${API_BASE}/accounts/auth/refresh-token`,
      { refreshToken },
      {
        headers: {
          Accept: 'text/plain',
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      },
    )
    .then(response => {
      return response.data.data as IResponse<IAuthToken>;
    })
    .catch(error => {
      return error.response.data;
    });
};
